(function(){
    'use strict';
    angular.module('Directives').directive('loadingSpinner', loadingSpinner);
    loadingSpinner.$inject = [];

    function loadingSpinner(){
        return {
            restrict: 'E',
            templateUrl: '/templates/directives/loadingSpinner.html',
            replace: true,
            scope: {
                class: '=?'
            },
            controller: loadingSpinnerController
        };

        function loadingSpinnerController(){}
    }
})()


// WEBPACK FOOTER //
// ./js/directives/loadingSpinner.js